import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useNavigate } from 'react-router-dom';
import { selectIsAuthenticated } from 'redux/authSlice';
import Logo from '../../assets/images/logo.svg';
import HeadBg from '../../assets/images/head-bg.png';
import { FloatingLabel, Form, Spinner } from 'react-bootstrap';
import 'react-input-code/dist/index.css';
import '../../styles/login.css';
import { useForgotPasswordMutation } from 'api/authApi';
import { showToastError, showToastSuccess } from 'components/toastify/ToastNotifications';

type Props = {}

const AdminForgotPassword = (props: Props) => {

    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);
    const isAuthenticated = useSelector(selectIsAuthenticated);
    const [email, setEmail] = useState<String>('');


    useEffect(() => {
        confirmAuthectication();
    }, []);

    const confirmAuthectication = () => {
        if (isAuthenticated) {
            navigate(-1);
        }
    };

    const [forgotPassword, data] = useForgotPasswordMutation();

    const handleInitiateReset = async (e: any) => {
        e.preventDefault();
        try {
            setLoading(true); // Set loading state to true
            const response = await forgotPassword(email).unwrap();
            if (response) {
                showToastSuccess(response.ResponseMessage);
            }
        } catch (error: any) {
            showToastError(error.data.ResponseMessage);
        } finally {
            setLoading(false); // Reset loading state to false after the mutation is complete
        }
    };

    return (
        <main className='login-section'>
            <header><img src={Logo} /></header>
            <div className='row mt-5 pt-5'>
                <div className='col-xl-4 col-lg-6 col-md-8 col-sm-12 bg-white p-0 m-auto rounded-4'>
                    <div>
                        <img src={HeadBg} className='rounded-bottom-0 rounded-top-4' width="100%" />
                        <div className='py-5 px-4 mx-2'>
                            <h5 className='fw-bold letter-spacing-1'>Forgot your password?</h5>
                            <span className='font-size-sm dark-text lh-sm'>Provide your registered email below to get a reset link from your email address.</span>
                            <Form onSubmit={handleInitiateReset} className='mb-3'>
                                <FloatingLabel controlId="floatingInput" label="Email Address" className="float-input my-4" >
                                    <Form.Control type='email' onChange={(e) => setEmail(e.target.value)} placeholder='Email Address' className="my-5 font-size-normal" />
                                </FloatingLabel>

                                <button type='submit' className='w-100 btn-primary rounded-5'>Proceed {loading && <Spinner size='sm' />}</button>
                            </Form>
                            <div className=' px-3 text-end'><Link to='/auth/login' className='primary-text text-decoration-none'>Back to login</Link></div>
                        </div>
                    </div>
                </div>
            </div>
        </main>
    )
};

export default AdminForgotPassword;
